export const MAP_DEFAULT_STATE: YMaps.IMapState = {
  controls: [],
};

export const MAP_VISIBLE_RESTRICT_AREA: [YMaps.TCoord, YMaps.TCoord] = [
  [41.1859, 19.6389],
  [81.8569, -168.9978],
];

export const MAP_DEFAULT_OPTIONS: YMaps.IMapOptions = {
  avoidFractionalZoom: true,
  // scrollZoomSmooth: true,
  layerLoadTilesInAction: true,
  autoFitToViewport: 'ifNull',
  restrictMapArea: MAP_VISIBLE_RESTRICT_AREA,
  suppressMapOpenBlock: true,
  yandexMapAutoSwitch: false,
  yandexMapDisablePoiInteractivity: true,
};

export function getMapConstructorOptions(options?: YMaps.IMapOptions | null): YMaps.IMapOptions {
  const mapOptions = { ...MAP_DEFAULT_OPTIONS, ...options };

  mapOptions.autoFitToViewport = MAP_DEFAULT_OPTIONS.autoFitToViewport;
  mapOptions.restrictMapArea = MAP_VISIBLE_RESTRICT_AREA;

  return mapOptions;
}

export const MAP_SET_CENTER_OPTIONS = {
  duration: 500,
  timingFunction: 'ease-in-out',
};

/**
 * Задержка дебаунса загрузки данных по жесту карты (мс). Серия actionend при быстром
 * зуме/перетаскивании схлопывается в один запрос на снимке последнего жеста.
 */
export const MAP_INTERACTION_RELOAD_DELAY = 200;
